import type { UserManager } from 'oidc-client-ts';
import { useContext } from 'react';
import { AuthContext } from '@/shared/AuthContext';
import { type AuthContextType } from '@/types';

export const useAuth = (): AuthContextType<UserManager> => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return context;
};
